import { Textbox } from "components/Textbox/Textbox";
import { useRef, useState } from "react";
import { ContactType, PhoneType } from "types/enum";

import { Button } from "components/Button/Button";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { SelectBox } from "components/Select/Select";
import { PersonDictionaryWithAdd } from "pages/InventoryAndSales/Sales/BaseDefinitionAndSetting/Customers/PersonDictionaryWithAdd";
import { postCustomerPhoneListApi } from "../api";

interface PersonContactFormPropsType {
  callerInfo?: any;
  reset?: any;
  onHide?: any;
}
export const PhoneForm = ({
  callerInfo,
  reset,
  onHide,
}: PersonContactFormPropsType) => {
  let data: any;
  //  const [contactType_, setContactType_] = useState(personContact?.ContactFixType || "Phone");

  const formRef = useRef<any>();



  const handlePersonContactFormSubmit = async (event) => {
    event.preventDefault();
    const data = {
      ContactType: +formRef.current.ContactType?.value,
      Description: formRef.current.Description?.value,
      ExtraDescription: formRef.current.ExtraDescription?.value,
      IsDefault: formRef.current.IsDefault?.checked,
      Value: callerInfo?.CallerNumber,
      PersonId: callerInfo?.PersonId
        ? callerInfo?.PersonId
        : formRef.current.PersonId?.value,
    };
    try {
      const res = await postCustomerPhoneListApi(data);
    } catch (error) {}
    onHide();
  };

  return (
    <div className="container-fluid">
      <form className="row align-items-center" ref={formRef}>
        <div className="col-lg-3 ps-0 ">
          <PersonDictionaryWithAdd
            name={"PersonId"}
            setShowPersonForm={() => {}}
            hasBorder={true}
            required={true}
            value={callerInfo?.PersonId ? callerInfo?.PersonId : null}
            mode={callerInfo?.PersonId ? "view" : "create"}
          />
        </div>
        <div className="col-lg-3 mb-3">
          <SelectBox
            required={true}
            lable="type"
            selectType="select"
            value={null}
            options={Object.keys(PhoneType).filter((key) => isNaN(Number(key)))}
            val={Object.keys(PhoneType)
              .filter((key) => isNaN(Number(key)))
              .map((key) => PhoneType[key])}
            name={"ContactType"}
          />
        </div>
        <div className="col-lg-3">
          <Textbox
            required={true}
            textboxName="Value"
            defaultValue={callerInfo?.CallerNumber}
            textboxType="text"
            labelText={"value"}
          />
        </div>
        <div className="col-lg-6">
          <Textbox
            textboxName="Description"
            textboxType="textarea"
            labelText={"Description"}
          />
        </div>
        <div className="col-lg-6">
          <Textbox
            textboxName="ExtraDescription"
            textboxType="textarea"
            labelText={"ExtraDescription"}
          />
        </div>
        <div className="col-md-4 col-sm-12">
          <CheckableButton
            labelText="IsDefault"
            type="checkbox"
            inputName="IsDefault"
          />
        </div>
      </form>
      <div className="d-flex justify-content-end">
        <Button
          btnType="submit"
          value={"save"}
          onClick={(e) => handlePersonContactFormSubmit(e)}
        />
      </div>
    </div>
  );
};
